import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GlobalMessage } from './models';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  // tslint:disable-next-line:variable-name
  private _sendListener: Subject<GlobalMessage>;

  get receiveListener() {
    return this._sendListener.asObservable();
  }

  constructor() {
    this._sendListener = new Subject<GlobalMessage>();
  }

  send(key: string, content: any) {
    const data = {
      date: (new Date()).getDate(),
      payload: content,
      tag: key,
      id: Date.now()
    } as unknown as GlobalMessage;

    this._sendListener.next(data);
  }

  receive(key: string): Observable<GlobalMessage> {
    const obs = new Subject<GlobalMessage>();
    this._sendListener.subscribe(
      (data) => {
        if (data.tag === key) {
          obs.next(data);
        }
      }
    );
    return obs;
  }

}
